<template>
  <div>
    <p class="headerstyle">เพิ่มวีดีโอ</p>
    <div class="w-full fromstyle">
      <form @submit.prevent="uploadLarge($event)">
        <br />
        <vs-input
          class="w-full"
          id="header"
          placeholder="ชื่อวีดีโอ"
          v-model="videoname"
          required
        />
        <br />
        <div class="flex items-center">
          <button type="button" class="upload-btn" @click="onPickFile">
            <img
              class="upload-btn-img"
              src="@/assets/images/elements/upload-btn.svg"
            />
          </button>
          <input
            type="file"
            accept="video/*"
            style="display: none"
            ref="fileInput"
            @change="pickFile($event)"
          />
          <p class="ml-3" v-if="this.File">{{ this.File.name }}</p>

          <!-- <p class="ml-3" v-if="vidPercent !== '0.00%'">กำลังอัพโหลด : {{ vidPercent }}</p> -->
        </div>
        <br />
        <b-progress v-show="vidPercent !== 0" class="mt-2" max="100" show-value>
          <b-progress-bar
            :value="vidPercent"
            variant="success"
          ></b-progress-bar>
        </b-progress>

        <br />

        <br />
        <div class="flex justify-center">
          <button class="share-btn" :disabled="isloading">
            เพิ่มวีดีโอ
          </button>
        </div>
        <p class="footer-text">
          วีดีโอเมื่อถูกเพิ่มแล้ว จะอยู่ในสถานะ “ยังไม่เผยแพร่” <br />
          โดยสามารถปรับเป็น “เผยแพร” ได้ในภายหลัง
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../util/backend";
import * as tus from "tus-js-client";
import baseUrl from "../../../util/baseUrl";

export default {
  methods: {
    onPickFile() {
      this.$refs.fileInput.click();
    },

    pickFile(e) {
      this.File = e.target.files[0];
      console.log(this.File);
    },

    uploadLarge(e) {
      if (this.File.length == 0) {
        this.$vs.notify({
          title: "การอัพโหลดวีดีโอ",
          text: "กรุณาเลือกไฟล์",
          color: "danger",
          icon: "check_box",
          position: "top-right"
        });
        return;
      }
      console.log("File", this.File);
      this.isloading = true;
      var file = this.File;
      let fileName = file.name;
      let fileType = file.type;
      let fileSize = file.size;
      let url = "";
      const getPercent = text => {
        console.log(this.vidPercent);
        this.vidPercent = text;
      };
      const addVideo = async () => {
        let config = {
          url: `${baseUrl.baseurl()}/addVideo`,
          method: "post",
          data: {
            video_uid: url,
            course_id: this.$route.params.id,
            description: "",
            name: this.videoname.trimLeft()
          }
        };

        await axios
          .api(config)
          .then(res => {
            this.$vs.notify({
              title: "การอัพโหลดวีดีโอ",
              text: "สำเร็จ",
              color: "success",
              icon: "check_box",
              position: "top-right"
            });
            this.$router.push({ path: `/course/${this.$route.params.id}` });
          })
          .catch(err => {
            this.isloading = false;
            this.$vs.notify({
              title: "Error message",
              text: `${
                err.response.data.error
                  ? err.response.data.error
                  : error
                  ? error
                  : "error"
              }`,
              color: "danger",
              icon: "error",
              position: "top-right"
            });
          });
      };
      // Create a new tus upload
      var upload = new tus.Upload(file, {
        endpoint: `${baseUrl.baseurl()}/uploadVideo`,
        removeFingerprintOnSuccess: true,
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem('token')}`,
        // },
        chunkSize: 50 * 1024 * 1024, // Required a minimum chunk size of 5MB, here we use 50MB.
        retryDelays: [0, 3000, 5000, 10000, 20000],
        metadata: {
          name: fileName,
          filename: fileName,
          filetype: fileType
          // requiresignedurls: true,
          // watermark: "deaa1dec879f99462b5c434613c8b1cd",
        },
        uploadSize: fileSize,
        onError: function(error) {
          console.log("Failed because: " + error);
          this.isloading = false;
        },
        onProgress: function(bytesUploaded, bytesTotal) {
          var percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
          console.log(bytesUploaded, bytesTotal, percentage + "%");
          getPercent(percentage);
        },
        onSuccess: function() {
          // console.log("Download %s from %s", upload.file.name, upload.url);
          addVideo();
        },
        onAfterResponse: function(req, res) {
          return new Promise(resolve => {
            var mediaIdHeader = res.getHeader("stream-media-id");
            if (mediaIdHeader) {
              url = mediaIdHeader;
              console.log("mediaIdHeader: ", mediaIdHeader);
            }
            resolve();
          });
        }
      });

      axios.api
        .post(`${baseUrl.baseurl()}/checkVideoNameExist`, {
          name: this.videoname.trimLeft(),
          course_id: this.$route.params.id
        })
        .then(res => {
          // Check if there are any previous uploads to continue.
          upload.findPreviousUploads().then(function(previousUploads) {
            // Found previous uploads so we select the first one.
            if (previousUploads.length) {
              upload.resumeFromPreviousUpload(previousUploads[0]);
            }
            // Start the upload
            upload.start();
          });
        })
        .catch(error => {
          this.$vs.notify({
            title: "Error message",
            text: `${
              error.response.data.error ? error.response.data.error : error
            }`,
            color: "danger",
            icon: "error",
            position: "top-right"
          });
          this.isloading = false;
        });
    }
  },
  async mounted() {},
  data() {
    return {
      File: [],
      vidLink: "",
      vidList: [],
      vidPercent: 0,
      player: null,
      videoname: null,
      isloading: false
    };
  },
  computed: {
    ...mapGetters({})
  }
};
</script>

<style lang="scss" scoped>
.uploadbanner {
  border: red;
  height: 100px;
}
.fromstyle {
  padding: 0;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
  &:disabled {
    background-color: gray;
    color: black;
  }
}

.radiobanner {
  display: flex;
  justify-content: flex-start;
}
.radioitem {
  margin-right: 10px;
}
.fixtimepicker {
  z-index: 99;
}
.bannerimage {
  height: 250px;
  max-width: 100%;
}

.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}
.back-btn {
  background: none !important;
  border: none;
  &:hover {
    transition: 10ms;
    padding-left: 10px;
  }
}
.uploadfield {
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-style: solid;
  border-color: #979aa1;
  border-radius: 10px;
  border-width: 2px;
  padding: 15px;
  background-color: #ffffff;
}
.upload-btn {
  border-radius: 10px;
  border-style: none;
  height: 42.5px;
}
.upload-btn-img {
  height: 42.5px;
}

.video-container {
  position: relative;
  padding-top: 56.25%;
  width: 100%;
}
</style>
